import {bool, object, string} from 'yup';
import {COUNTRIES_UPPERCASE} from '../../../../../constants/countries';
import {fileSchema} from "../../../FormHandlers";

const countriesIds = COUNTRIES_UPPERCASE.map((el) => el[1])

export default object({
  company_name: string().trim().required(),
  reg_number: string().trim().required(),
  nature: string().oneOf(['General', 'Gambling']).required(),
  register_street: string().trim().required(),
  register_address: string(),
  register_zip: string().trim().required(),
  register_city: string().trim().required(),
  register_country: string().required().oneOf(countriesIds),
  operating_equals_business: bool().default(false),
  operating_street: string().trim().required().when('operating_equals_business', {
    is: true,
    then: () => string(),
  }),
  operating_address: string(),
  operating_zip: string().trim().required().when('operating_equals_business', {
    is: true,
    then: () => string(),
  }),
  operating_city: string().trim().required().when('operating_equals_business', {
    is: true,
    then: () => string(),
  }),
  operating_country: string().required().oneOf(countriesIds).when('operating_equals_business', {
    is: true,
    then: () => string(),
  }),
  business_registration_extract: fileSchema,
  business_operating_address: fileSchema,
  share_holder_structure: fileSchema,
})
